
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsPosProcessModeGrid extends Serenity.EntityGrid<PsPosProcessModeRow, any> {
        protected getColumnsKey() { return PsPosProcessModeColumns.columnsKey; }
        protected getDialogType() { return PsPosProcessModeDialog; }
        protected getIdProperty() { return PsPosProcessModeRow.idProperty; }
        protected getInsertPermission() { return PsPosProcessModeRow.insertPermission; }
        protected getLocalTextPrefix() { return PsPosProcessModeRow.localTextPrefix; }
        protected getService() { return PsPosProcessModeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}